import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite';
import EChartsReact from 'echarts-for-react';

export default observer(function Gender({ currentAuthentication }) {
  const malePercentage = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.gender?.male || 0, [currentAuthentication?.audience_information?.detailed_audience_stats?.gender?.male])
  const femalePercentage = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.gender?.female || 0, [currentAuthentication?.audience_information?.detailed_audience_stats?.gender?.female])

  const option = useMemo(() => ({
    yAxis: {
      type: 'category',
      data: ['Female', 'Male'],
      axisLine: { show: false },
      axisTick: { show: false }
    },
    xAxis: {
      show: false,
      max: 100
    },
    series: [{
      type: 'bar',
      data: [
        {
          value: (femalePercentage * 100).toFixed(2),
          itemStyle: { color: '#2CCDB4' }
        },
        {
          value: (malePercentage * 100).toFixed(2),
          itemStyle: { color: '#C1F6EE' }
        }
      ],
      label: {
        show: true,
        position: 'right',
        formatter: '{c}%',
        fontSize: 14,
        fontWeight: 'bold'
      },
      barWidth: '40%'
    }],
    grid: {
      left: 60,
      right: 50,
      top: 0,
      bottom: 0
    }
  }), [malePercentage, femalePercentage])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-lg">
      <p className="font-bold text-xl mb-4 dark:text-white">Gender</p>
      <EChartsReact option={option} style={{ width: '100%', height: '180px' }} />
    </div>
  )
})
